module.exports = __webpack_public_path__ + "img/ok-dashboard-green.5f63cc5a.svg";